import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface MSISDNValidationCSSStyle extends UIComponentCSSStyle{
    
    getHeaderDivCSSStyle(): object ;
    getTitleCSSStyle(): object ;
    getCloseIconDivCSSStyle(): object ;
    getCloseIconCSSStyle(): object ;
    getMobileNumberCSSStyle():object;



}
export class MSISDNValidationCSSStyleImpl extends UIComponentCSSStyleImpl
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "100%",
            height: "auto",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            borderRadius: "8px",
            flexFlow: "row wrap",
            position:'relative',
            objectFit:'fill',
            justifyContent:'center',
            itemAlign:'center',
            paddingBottom:'30px'
        };
    }

    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
            marginLeft:'31.5px',
            marginRight:'31.5px'
        };
    }
    getTitleCSSStyle(): object {
        return {
            width: "90%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft:"50px",
            paddingRight: "60px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center",
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/msisdnvalidation/msisdnvalidationcss.tsx